import React, { useContext, useEffect, useState, useRef } from "react";
import axiosInstance from "../../api";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import { triggerscroll } from "../Homepage/Homepage";
import moment from "moment";

function Invoices({ setEnquiryId }) {
  const [data, setData] = useState([]);
  const [refresh, setrefresh] = useState(false);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, userData, permissionsdata } =
    useContext(triggerscroll);
  const nav = useNavigate();

  useEffect(() => {
    setloading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/Invoice/GetAllInvoices`)
      .then((res) => {
        setData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [refresh]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Invoice" && x.isRead === true
    );
    return issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" &&
        x.subHead === "Invoice" &&
        x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section>
      <center>
        <br />
        <h1>Invoices</h1>
      </center>
      <section className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(8, 1fr)" }}>
              <blockquote>Sr.No.</blockquote>
              <blockquote>Invoice Number</blockquote>
              <blockquote>Payment Mode</blockquote>
              <blockquote>Buyers Order Number</blockquote>
              <blockquote>Linked To Quotation Id</blockquote>
              <blockquote>Date Created</blockquote>
              <blockquote style={{ gridColumn: "span 2" }}>Actions</blockquote>
            </aside>
          </div>
          <div>
            {readPermission() ? (
              loading ? (
                <aside style={{ gridTemplateColumns: "repeat(8, 1fr)" }}>
                  <blockquote style={{ gridColumn: "span 8" }}>
                    <center>
                      <i
                        className="fa-solid fa-spinner fa-spin"
                        style={{ fontSize: "2.5rem" }}
                      ></i>
                    </center>
                  </blockquote>
                </aside>
              ) : data.length > 0 ? (
                data.map((invoice) => (
                  <aside style={{ gridTemplateColumns: "repeat(8, 1fr)" }}>
                    <blockquote>{invoice.id}</blockquote>
                    <blockquote>{invoice.invoiceNumber}</blockquote>
                    <blockquote>{invoice.paymentMode}</blockquote>
                    <blockquote>{invoice.buyersOrderNumber}</blockquote>
                    <blockquote>{invoice.quotation?.seriesId}</blockquote>
                    <blockquote>
                      {moment(new Date(invoice.createdDate)).format(
                        "DD/MM/YYYY"
                      )}
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        setEnquiryId(
                          invoice.quotation?.ticket?.enquirySeriesId
                        );
                        nav(
                          `/dashboard/checkin/steps/step5/${invoice.quotation?.id}`
                        );
                      }}
                    >
                      <i className="fa-solid fa-eye"></i>
                    </blockquote>
                    <blockquote
                      style={{
                        pointerEvents: deletePermission() && "none",
                      }}
                      onClick={() => {
                        Swal.fire({
                          icon: "error",
                          title: "Are You Sure",
                          text: "This Invoice Will Get Deleted Permanently",
                          showCancelButton: true,
                          showConfirmButton: true,
                        }).then((result) => {
                          if (result.isConfirmed)
                            axiosInstance
                              .delete(
                                `${process.env.REACT_APP_API_URL}/api/Invoice/DeleteInvoice/${invoice.id}`
                              )
                              .then((res) => {
                                toast.success(res.data, {
                                  position: "bottom-center",
                                  theme: "dark",
                                });
                                setrefresh(!refresh);
                              })
                              .catch(console.log);
                        });
                      }}
                    >
                      <i
                        className="fa-solid fa-trash"
                        style={{ color: deletePermission() && "gray" }}
                      ></i>
                    </blockquote>
                  </aside>
                ))
              ) : (
                <aside style={{ gridTemplateColumns: "repeat(8, 1fr)" }}>
                  <blockquote style={{ gridColumn: "span 8" }}>
                    <center>No Records Found</center>
                  </blockquote>
                </aside>
              )
            ) : (
              <aside style={{ gridTemplateColumns: "repeat(8, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 8" }}>
                  <center>You Do Not Have Permission To Read Data</center>
                </blockquote>
              </aside>
            )}
          </div>
        </section>
      </section>
    </section>
  );
}

export default Invoices;
